export default "__VITE_ASSET__Bfgt7o5O__"